import React from "react";

import { ReactComponent as NoGraph } from "@src/assets/images/no_graph.svg";
import { Box, Typography } from "@mui/material";

import { useSelector } from "react-redux";

import { selectCurrentLanguage } from "@src/store/app_manager/selector";

import data from "@src/data/data.json";

export const NoGraphComponent: React.FC = () => {
  const currentLanguage = useSelector(selectCurrentLanguage);

  const locale = data[currentLanguage].Analytics.NoGraphByDateTitle;
  return (
    <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
      <NoGraph />
      <Typography fontSize={"18px"} marginTop={"20px"}>
        {locale.Title}
      </Typography>
    </Box>
  );
};